var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserEdit = function SvgUserEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6 10.333H5c-.93 0-1.396 0-1.774.115a2.67 2.67 0 0 0-1.778 1.778c-.115.378-.115.844-.115 1.774m8.334-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2.334 9 2.068-.59c.099-.029.148-.043.195-.064a.7.7 0 0 0 .116-.069 1.4 1.4 0 0 0 .15-.14l4.305-4.304A1.178 1.178 0 1 0 12.5 7.167L8.195 11.47c-.072.073-.109.11-.139.15a.7.7 0 0 0-.068.117c-.021.046-.036.095-.064.194z"
  })));
};
export default SvgUserEdit;